import { graphql, useStaticQuery } from 'gatsby'

export const getFilterableTaxonomy = (): {
  title: string
  type: string
  primaryFocus: string
  is_filterable: boolean
}[] => {
  const data = useStaticQuery(graphql`
    query {
      filterableTaxonomy: allTaxonomy(filter: { is_filterable: { eq: true } }) {
        edges {
          node {
            title
            type
            is_filterable
            primaryFocus
          }
        }
      }
    }
  `)
  return data.filterableTaxonomy.edges
}
